import { useEffect, useState } from "react"
import type { AppShell } from "@/App"
import { fetchSettings } from "@/lib/api"

/**
 * Potência por m² de dimensionamento de um módulo, das Configurações
 * (`<kind>_config.w_per_m2`) — a mesma que o motor usa. Enquanto carrega (ou
 * sem valor gravado) devolve o default do motor.
 */
export function useModuleWPerM2(
  shell: AppShell | null,
  key: "ac_config" | "bc_aq_config",
  fallback: number,
): number {
  const [w, setW] = useState(fallback)
  useEffect(() => {
    if (!shell) return
    let cancelled = false
    fetchSettings(shell)
      .then((s) => {
        const v = Number((s[key] as { w_per_m2?: unknown } | null | undefined)?.w_per_m2)
        if (!cancelled && Number.isFinite(v) && v > 0) setW(v)
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [shell, key])
  return w
}

/** Defaults do motor (functions/lib/engine/ac.ts e bc_aq.ts). */
export const AC_DEFAULT_W_PER_M2 = 120
export const BC_AQ_DEFAULT_W_PER_M2 = 100
/** 1 W = 3,412 BTU/h — igual ao motor. */
export const W_TO_BTU = 3.412142
